import * as React from 'react';
import { AccordionItem as AccordionItem$1 } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { CardGlassesConfiguration } from '../CardGlassesConfiguration/CardGlassesConfiguration.js';
import { GlassesPrescription } from '../GlassPrescription/GlassesPrescription.js';
import { PrescriptionTableContainer } from '../PrescriptionTable/PrescriptionTableContainer.js';

const AccordionItem = (props)=>{
    const intl = useIntl();
    const labels = React.useMemo(()=>({
            deliveryInterval: intl.getLabel('cart.item.subscription.deliveryInterval'),
            day: intl.getLabel('common.duration.day'),
            days: intl.getLabel('common.duration.days')
        })
    , [
        intl
    ]);
    switch(props.type){
        case 'CONTACT_LENSES':
            {
                return /*#__PURE__*/ React.createElement(AccordionItem$1, {
                    variant: "narrow",
                    label: props.title,
                    id: props.id,
                    expanded: props.expanded
                }, /*#__PURE__*/ React.createElement(PrescriptionTableContainer, {
                    size: "narrow",
                    orientation: "eyeSideTop",
                    prescription: props.prescription
                }));
            }
        case 'CONTACT_LENS_BUNDLE':
            {
                return /*#__PURE__*/ React.createElement(AccordionItem$1, {
                    variant: "narrow",
                    label: props.title,
                    id: props.id,
                    expanded: props.expanded
                }, /*#__PURE__*/ React.createElement(CardGlassesConfiguration, {
                    bundleChildLineItems: props.bundleChildLineItems
                }));
            }
        case 'GLASSES_BUNDLE':
            {
                return /*#__PURE__*/ React.createElement(AccordionItem$1, {
                    variant: "narrow",
                    label: props.title,
                    id: props.id,
                    expanded: props.expanded
                }, /*#__PURE__*/ React.createElement(GlassesPrescription, {
                    intl: intl,
                    prescription: props.prescription,
                    prescriptionsUrl: props.prescriptionsUrl
                }));
            }
        case 'SUBSCRIPTION':
            {
                return /*#__PURE__*/ React.createElement(AccordionItem$1, {
                    variant: "narrow",
                    label: props.title,
                    id: props.id,
                    expanded: props.expanded
                }, /*#__PURE__*/ React.createElement(Text, {
                    variant: "body-head"
                }, labels.deliveryInterval), /*#__PURE__*/ React.createElement(Text, null, `${props.deliveryInterval} ${props.deliveryInterval === 1 ? labels.day : labels.days}`));
            }
        default:
            return null;
    }
};

export { AccordionItem };
//# sourceMappingURL=AccordionItem.js.map
